import React, { useState, useEffect } from "react";
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector,useDispatch } from 'react-redux';
import Register from './pages/Register/Register.js';
import Navbar from './components/Navbar.js';
import logo from "./assets/images/logoBranca.png";
import Home from "./pages/Home/Home";
import HowPlay from "./pages/HowPlay/HowPlay.js";
import Ranking from "./pages/Ranking/Ranking";
import Challenge from "./pages/Challenge/Challenge.js";
import BuyCoins from "./pages/Coins/BuyCoins.js";
import Progress from "./pages/Progress/Progress.js";
import Admin from "./pages/Admin/Admin.js";
import Login from "./pages/Login/Login.js";
import EditProfile from './pages/EditProfile/EditProfile.js';
import EditChallenge from './pages/Admin/EditChallenge.js';
import Logout from './pages/Logout/Logout.js';
import backgroundImage from "./assets/images/background.webp"; // Importando imagem
import bgParallax from './assets/images/parallax.webp';
import parallax from "./assets/images/parallax.png"; // Importando imagem
import { checkSession } from "./slices/authSlice";
import Footer from "./components/Footer.js"
import Joyride from "react-joyride";

function App() {
  const dispatch = useDispatch();
  const { user, isAuthenticated, loading } = useSelector((state) => state.auth);
  const [runTour, setRunTour] = useState(false);

  useEffect(() => {
    dispatch(checkSession()); // Tenta carregar a sessão automaticamente
  }, [dispatch]);

  useEffect(() => {
    // Inicia o tutorial assim que os dados do usuário estiverem disponíveis
    if (user) {
      setRunTour(true);
    }
  }, [user]);

  if (loading) {
    return <p>Carregando...</p>
  }

  const ProtectedRoute = ({ children }) => {
    return isAuthenticated  ? children : <Navigate to="/Login" />;
  };

  const steps = [
    {
      target: ".ranking-header", // Seleciona o título do ranking
      content: "Aqui você pode ver o ranking dos jogadores.",
    },
    {
      target: ".ranking-table", // Seleciona a tabela
      content: "Aqui estão os jogadores classificados com suas pontuações.",
    },
    {
      target: ".user-avatar", // Avatar do usuário
      content: "Este é o seu avatar, você pode personalizá-lo!",
    },
    {
      target: ".points", // A pontuação
      content: "Aqui você pode ver sua pontuação atual!",
    },
    {
      target: ".get-hints", // Dicas do jogo
      content: "Você pode usar moedas para obter dicas!",
    },
  ];

  return (
    <>
      {/* Tutorial */}
      <Joyride
        steps={steps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        scrollToFirstStep
      />
    <div className="min-h-screen bg-gradient-to-b from-blue-500 to-indigo-700 text-white overflow-y-scroll">
      <BrowserRouter>
      <div className="relative text-center py-20 bg-cover bg-fixed" style={{ backgroundImage: `url(${bgParallax})` }}>
          <Navbar />
          <div className="mt-4">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/Login" element={!isAuthenticated ? <Login /> : <Navigate to="/Progress" />} />
              <Route path="/Register" element={!isAuthenticated  ? <Register /> : <Navigate to="/Progress" />} />
              
              {/* Rotas protegidas */}
              <Route path="/Admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              <Route path="/Progress" element={<ProtectedRoute><Progress /></ProtectedRoute>} />
              <Route path="/Challenge/:id" element={<ProtectedRoute><Challenge /></ProtectedRoute>} />
              <Route path="/EditProfile" element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />
              <Route path="/EditChallenge/:id" element={<ProtectedRoute><EditChallenge /></ProtectedRoute>} />
              <Route path="/BuyCoins" element={<ProtectedRoute><BuyCoins /></ProtectedRoute>} />
              {/* Rotas Públicas */}
              <Route path="/HowPlay" element={<HowPlay />} />
              <Route path="/Ranking" element={<Ranking />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </div>
    </>
  );
}

export default App;
